import { z } from 'zod';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';
import { DbClassicPinComponentTypeSchema } from './classic-pin-component';

const UnsupportedPinComponentSettingsSchema = BasePinComponentSettingsSchema.extend(
  z.object({
    originalType: DbClassicPinComponentTypeSchema,
  }).shape
);

export type UnsupportedPinComponentSettings = z.infer<typeof UnsupportedPinComponentSettingsSchema>;

export const UnsupportedPinComponentTypeSchema = z.literal('UNSUPPORTED');

export const UnsupportedPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: UnsupportedPinComponentTypeSchema,
    settings: UnsupportedPinComponentSettingsSchema,
  }).shape
);
